import type { MetricFilterAdapter } from "@/metrics/runtime-adapters"

import type { MetricValueFilter } from "@/lib/metricValueFilters"
import type { RunRowLike } from "@/types/RunRow"

import { applyMetricFilters } from "./metricFilterUtils"
import { applyMutationFilters } from "./mutationFilterUtils"
import { applyStatusFilters } from "./statusFilterUtils"

export interface RunResultsFilterState {
  metricFilters: MetricValueFilter[]
  mutationFilterIds: string[]
  statusFilterStatuses: string[]
}

interface FilterRunRowsParams {
  runRows: RunRowLike[]
  metricRecordsById: Record<string, MetricFilterAdapter>
  filters: RunResultsFilterState
}

export function filterRunRows({
  runRows,
  metricRecordsById,
  filters,
}: FilterRunRowsParams): RunRowLike[] {
  return applyStatusFilters(
    applyMutationFilters(
      applyMetricFilters(runRows, filters.metricFilters, metricRecordsById),
      filters.mutationFilterIds,
    ),
    filters.statusFilterStatuses,
  )
}
